var thumbRating = {
    init: function() {
        thumbRating.action();
    },
    box: '',
    action: function() {
        $('body').on('click', '.thumb-rating-action', function() {
            const that = $(this);
            let parent = that.parents('.thumb-rating-box');

            thumbRating.box = parent;

            if (that.hasClass('up')) {
                thumbRating.request('up');
            } else if (that.hasClass('down') && !that.hasClass('active')) {
                that.addClass('active');
                thumbRating.renderImproveBox(this, parent);
            }
        });
    },
    renderImproveBox: function(parent, child) {
        let improveBox = document.createElement('span');
        improveBox.id = 'thumb-rating-improve-box';
        improveBox.className = 'thumb-rating-improve-box';

        let close = document.createElement('a');
        close.id = 'close-improve-box';
        close.className = 'pointer';

        improveBox.appendChild(close);

        let label = document.createElement('label');
        label.setAttribute('for', 'thumb-rating-comment');
        label.classList.add('dc-ui');
        label.classList.add('block');
        label.classList.add('mb-8');
        label.textContent = child.data('label');
        improveBox.appendChild(label);

        let textarea = document.createElement('textarea');
        textarea.id = 'thumb-rating-comment';
        textarea.name = 'thumb-rating-comment';
        textarea.classList.add('textarea');
        textarea.classList.add('thumb-rating-textarea');
        improveBox.appendChild(textarea);

        let button = document.createElement('button');
        button.id = 'thumb-rating-btn';
        button.classList.add('button');
        button.classList.add('button-align-right');
        button.classList.add('submit');
        button.textContent = child.data('button');
        improveBox.appendChild(button);

        parent.append(improveBox);

        if ($(improveBox).offset().left + $(improveBox).outerWidth() > $(window).width()) {
            $(improveBox).addClass('top-right');
        } else {
            $(improveBox).removeClass('top-right');
        }

        thumbRating.close();
        thumbRating.validate();
    },
    close: function() {
        $('body').on('click', function(e) {
            if (!$(e.target).hasClass('thumb-rating-action') && !$(e.target).hasClass('thumb-rating-improve-box') && $(e.target).parents('.thumb-rating-improve-box').length === 0 && $('.thumb-rating-improve-box').length > 0) {
                $('#close-improve-box').trigger('click');
            }
        });

        $('#close-improve-box').on('click', function() {
            const that = $(this);
            that.parents('.thumb-rating-action.active').removeClass('active');
            that.parent().remove();
        });
    },
    validate: function() {

        $('#thumb-rating-btn').on('click', function() {
            const that = $(this);
            const comment = $('#thumb-rating-comment');
            const val = comment.val();

            that.addClass('loading');

            if (val.length > 0) {
                that.prop('disabled', true);
                comment.removeClass('error');
                thumbRating.request('down');
            } else {
                comment.addClass('error');
                setTimeout(function() {
                    that.removeClass('loading');
                }, 0);
            }
        });

        $('#thumb-rating-comment').on('keyup', function() {
            const that = $(this);

            if (that.val().length > 0) {
                that.removeClass('error');
            }
        });

    },
    request: function(mode) {
        let postObject = [];

        postObject['mode'] = (mode === 'down' ? 0 : 1);
        if (mode === 'down') {
            postObject['comment'] = $('#thumb-rating-comment').val();
        }

        const jsonObj = thumbRating.box.data('json');
        const requestURL = thumbRating.box.data('url');
        for (let x in jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, x)) {
                postObject[x] = jsonObj[x];
            }
        }

        if (mode === 'down') {
            setTimeout(function() {
                thumbRating.showMessage(mode);
            }, 700);
        } else {
            thumbRating.showMessage(mode);
        }

        $.postJSON(requestURL, postObject);
    },
    showMessage: function(mode) {
        let message = thumbRating.box.next('.thumb-rating-message');
        let messageText = message.data(mode);

        thumbRating.box.hide();
        message.text(messageText).fadeIn();
    }
};
